import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import TabsView from "@/layouts/tabs/TabsView";
import BlankView from "@/layouts/BlankView";
import PageView from "@/layouts/PageView";
import dd from "@/assets/dd.svg";
import kh from "@/assets/kh.svg";
import ps from "@/assets/ps.svg";
import sp from "@/assets/sp.svg";
import sz from "@/assets/sz.svg";
import wz from "@/assets/wz.svg";
import yx from "@/assets/yx.svg";
import zs from "@/assets/zs.svg";
import affiliate from '@/assets/affiliate.svg';
import Vue from "vue";

//路由配置
var options = {
  routes: [{
    path: "/login",
    name: "登录页",
    component: function component() {
      return import("@/pages/login");
    }
  }, {
    path: "*",
    name: "404",
    component: function component() {
      return import("@/pages/exception/404");
    }
  }, {
    path: "/403",
    name: "403",
    component: function component() {
      return import("@/pages/exception/403");
    }
  }, {
    path: "/design",
    name: "design",
    component: function component() {
      return import("@/pages/design/index");
    }
  }, {
    path: "/design/preview",
    name: "预览",
    component: function component() {
      return import("@/pages/design/layout/preview");
    }
  }, {
    path: "/designCategory",
    name: "分类装修",
    component: function component() {
      return import("@/pages/designCategory/index");
    }
  }, {
    path: "/designCategory/preview",
    name: "预览",
    component: function component() {
      return import("@/pages/designCategory/layout/preview");
    }
  }, {
    path: "/",
    name: "",
    component: TabsView,
    redirect: "/home",
    children: [{
      path: "home",
      name: "home",
      component: function component() {
        return import("@/pages/home/index");
      },
      meta: {
        title: "首页",
        invisible: true,
        noCrumb: true
      }
    }, {
      path: "design",
      name: "店铺装修",
      redirect: "/design/home",
      component: BlankView,
      meta: {
        title: "店铺装修",
        invisible: false,
        icon: zs
      },
      children: [{
        path: "/design/home",
        name: "页面装修",
        redirect: "/design",
        component: function component() {
          return import("@/pages/design/index.vue");
        },
        meta: {
          title: "页面装修",
          target: "design",
          link: "/#/design"
        }
      }, {
        path: "designcategory",
        name: "移动端分类",
        component: function component() {
          return import("@/pages/designCategory2/category.vue");
        },
        meta: {
          title: "移动端分类"
        }
      }
      // {
      // 	path: '/design/category',
      // 	name: '移动端分类装修',
      // 	redirect: '/designCategory',
      // 	component: () => import('@/pages/designCategory/index.vue'),
      // 	meta: {
      // 		title: '移动端分类装修',
      // 		target: 'design',
      // 		link: '/#/designCategory'
      // 	}
      //
      // }
      ]
    }, {
      path: "productmanager",
      name: "商品管理",
      component: BlankView,
      redirect: "/productmanager/productList",
      meta: {
        title: "商品管理",
        icon: sp
      },
      children: [{
        path: "/productmanager/productList",
        name: "商品列表",
        component: BlankView,
        redirect: "/productmanager/productList",
        meta: {
          title: "商品列表"
        },
        children: [{
          path: "/productmanager/productList",
          name: "商品列表",
          component: function component() {
            return import("@/pages/productmanager/productList/productList");
          },
          meta: {
            title: "商品列表",
            noCrumb: true,
            invisible: true
          }
        }, {
          path: "/productmanager/productDetail",
          name: "商品详情",
          component: function component() {
            return import("@/pages/productmanager/productDetail");
          },
          meta: {
            title: "商品详情",
            invisible: true
          }
        }]
      }, {
        path: "sourcearea",
        name: "原产地列表",
        component: function component() {
          return import("@/pages/productmanager/sourearealist/sourcearea");
        },
        meta: {
          title: "原产地列表"
          // keepAlive: true
        }
      }, {
        path: "brand",
        name: "品牌列表",
        component: function component() {
          return import("@/pages/productmanager/brandlist/brandList");
        },
        meta: {
          title: "品牌列表"
          // keepAlive: true
        }
      }, {
        path: "category",
        name: "商品分类",
        component: function component() {
          return import("@/pages/productmanager/categorylist/category");
        },
        meta: {
          title: "商品分类"
        }
      },
      // {
      //   path: "comment",
      //   name: "商品评论",
      //   component: () =>
      //     import("@/pages/productmanager/comment/commentList"),
      //   meta: {
      //     title: "商品评论",
      //   },
      // },
      {
        path: "productNotice",
        name: "到货通知",
        component: BlankView,
        redirect: "/productNotice/list",
        meta: {
          title: "到货通知"
        },
        children: [{
          path: "/productNotice/list",
          name: "到货通知",
          component: function component() {
            return import("@/pages/productmanager/arrivalNotice/noticeList");
          },
          meta: {
            title: "到货通知",
            invisible: true,
            noCrumb: true
          }
        }, {
          path: "/productNotice/add",
          name: "新建到货通知",
          component: function component() {
            return import("@/pages/productmanager/arrivalNotice/addNotice");
          },
          meta: {
            title: "新建到货通知",
            invisible: true
          }
        }, {
          path: "/productNotice/edit",
          name: "编辑到货通知",
          component: function component() {
            return import("@/pages/productmanager/arrivalNotice/addNotice");
          },
          meta: {
            title: "编辑到货通知",
            invisible: true
          }
        }]
      }, {
        path: "labelingManagement",
        name: "商品标签",
        component: function component() {
          return import("@/pages/productmanager/labelingManagement");
        },
        meta: {
          title: "商品标签"
        }
      }, {
        path: "goodsGrouped",
        name: "商品分组",
        component: BlankView,
        redirect: "/goodsGrouped/list",
        meta: {
          title: "商品分组"
        },
        children: [{
          path: "/goodsGrouped/list",
          name: "商品分组",
          component: function component() {
            return import("@/pages/productmanager/goodsGrouped/list");
          },
          meta: {
            title: "商品分组",
            invisible: true,
            noCrumb: true
          }
        }, {
          path: "/goodsGrouped/editGoodsGrouped",
          name: "编辑商品分组",
          component: function component() {
            return import("@/pages/productmanager/goodsGrouped/editGroup");
          },
          meta: {
            title: "编辑商品分组",
            invisible: true
          }
        }, {
          path: "/goodsGrouped/addGoodsGrouped",
          name: "新建商品分组",
          component: function component() {
            return import("@/pages/productmanager/goodsGrouped/addGroup");
          },
          meta: {
            title: "新建商品分组",
            invisible: true
          }
        }]
      }, {
        path: "goodsVisible",
        name: "商品可见性设置",
        component: BlankView,
        redirect: "/goodsVisible/list",
        meta: {
          title: "商品可见性设置"
        },
        children: [{
          path: "/goodsVisible/list",
          name: "商品可见性设置",
          component: function component() {
            return import("@/pages/productmanager/goodsVisible/list");
          },
          meta: {
            title: "商品可见性设置",
            invisible: true,
            noCrumb: true
          }
        }, {
          path: "/goodsVisible/addGoodsVisible",
          name: "新建商品可见性设置",
          component: function component() {
            return import("@/pages/productmanager/goodsVisible/addVisible");
          },
          meta: {
            title: "新建商品可见性设置",
            invisible: true
          }
        }, {
          path: "/goodsVisible/editGoodsVisible",
          name: "编辑商品可见性设置",
          component: function component() {
            return import("@/pages/productmanager/goodsVisible/editVisible");
          },
          meta: {
            title: "编辑商品可见性设置",
            invisible: true
          }
        }]
      }
      // {
      //   path: "goodsErp",
      //   name: "ERP新增商品提醒",
      //   component: () =>
      //     import("@/pages/productmanager/goodsErp/list"),
      //   meta: {
      //     title: "ERP新增商品提醒",
      //   },
      // },
      // {
      //   path: "bargain",
      //   name: "特卖品管理",
      //   component: () => import("@/common/productmanager/bargain"),
      //   meta: {
      //     title: "特卖品管理",
      //   },
      // },
      ]
    }, {
      path: "customermanager",
      name: "得意先管理",
      component: BlankView,
      redirect: "customermanager/customerlist",
      meta: {
        title: "得意先管理",
        icon: kh
      },
      children: [{
        path: "customermanager",
        name: "得意先列表",
        component: BlankView,
        redirect: "/customermanager/customerlist",
        meta: {
          title: "得意先列表"
        },
        children: [{
          path: "/customermanager/customerlist",
          name: "得意先列表",
          component: function component() {
            return import("@/pages/customer/customerList");
          },
          meta: {
            title: "得意先列表",
            invisible: true,
            noCrumb: true
            // keepAlive: true
          }
        },
        // {
        //   path: "/customermanager/editcustomer",
        //   name: "编辑用户",
        //   component: () => import("@/pages/customer/editcustomer"),
        //   meta: {
        //     title: "编辑客户",
        //     invisible: true,
        //     keepAlive: false,
        //   },
        // },
        {
          path: "/customermanager/editcustomer2",
          name: "编辑得意先",
          component: function component() {
            return import("@/pages/customer/editcustomer2");
          },
          meta: {
            title: "编辑得意先",
            invisible: true,
            keepAlive: false
          }
        }]
      }, {
        path: "dyxDisGroup",
        name: "得意先分组",
        component: BlankView,
        redirect: 'customermanager/dyxDisGroup',
        meta: {
          title: "得意先分组"
        },
        children: [{
          path: "/customermanager/dyxDisGroup",
          name: "得意先分组",
          component: function component() {
            return import("@/pages/dyxmanager/dyxDisGroup/dyxDisGroup");
          },
          meta: {
            title: "得意先分组",
            invisible: true,
            noCrumb: true
          }
        }, {
          path: "/dyxDisGroup/adddyx",
          name: "新建得意先分组",
          component: function component() {
            return import("@/pages/dyxmanager/dyxDisGroup/adddyx");
          },
          meta: {
            title: "新建得意先分组",
            invisible: true
          }
        }, {
          path: "/dyxDisGroup/editdyx",
          name: "编辑得意先分组",
          component: function component() {
            return import("@/pages/dyxmanager/dyxDisGroup/editdyx");
          },
          meta: {
            title: "编辑得意先分组",
            invisible: true
          }
        }]
      }, {
        path: "captchaRecordList",
        name: "验证码发送记录",
        component: function component() {
          return import("@/pages/customer/captchaRecordList");
        },
        meta: {
          title: "验证码发送记录"
          // keepAlive: true
        }
      }, {
        path: "contactUs",
        name: "咨询管理",
        component: function component() {
          return import("@/pages/customer/contact-us");
        },
        meta: {
          title: "咨询管理"
          // keepAlive: true
        }
      }]
    }, {
      path: "/order",
      name: "订单管理",
      component: BlankView,
      redirect: "/orderList",
      meta: {
        title: "订单管理",
        // icon: task
        icon: dd
      },
      children: [{
        path: "/orderManager",
        name: "订单列表",
        component: BlankView,
        redirect: "/orderList",
        meta: {
          title: "订单列表"
          // icon: task
        },
        children: [{
          path: "/orderList",
          name: "orderList",
          component: function component() {
            return import("@/pages/order/orderList");
          },
          meta: {
            // icon: type,
            title: "订单列表",
            invisible: true,
            noCrumb: true
          }
        }, {
          path: "/orderDetail",
          name: "orderDetail",
          component: function component() {
            return import("@/pages/order/orderDetail");
          },
          meta: {
            // icon: type,
            title: "订单详情",
            invisible: true
          }
        }]
      }, {
        path: "/order2Manager",
        name: "传票列表",
        component: BlankView,
        redirect: "/orderList2",
        meta: {
          title: "传票列表"
          // icon: task
        },
        children: [{
          path: "/orderList2",
          name: "传票列表",
          component: function component() {
            return import("@/pages/order/orderList2");
          },
          meta: {
            // icon: type,
            title: "传票列表",
            invisible: true,
            noCrumb: true
          }
        }, {
          path: "/orderDetail2",
          name: "传票详情",
          component: function component() {
            return import("@/pages/order/orderDetail2");
          },
          meta: {
            // icon: type,
            title: "传票详情",
            invisible: true
          }
        }]
      }, {
        path: "/inquiryManager",
        name: "询价单列表",
        component: BlankView,
        redirect: "/inquiryList",
        meta: {
          title: "询价单列表"
          // icon: task
        },
        children: [{
          path: "/inquiryList",
          name: "询价单列表",
          component: function component() {
            return import("@/pages/order/inquiry/inquiryList");
          },
          meta: {
            // icon: type,
            title: "询价单列表",
            invisible: true,
            noCrumb: true
          }
        }, {
          path: "/inquiryDetail",
          name: "询价单详情",
          component: function component() {
            return import("@/pages/order/inquiry/inquiryDetail");
          },
          meta: {
            // icon: type,
            title: "询价单详情",
            invisible: true
          }
        }]
      }, {
        path: "/quoteManager",
        name: "见绩书列表",
        component: BlankView,
        redirect: "/quoteList",
        meta: {
          title: "见绩书列表"
          // icon: task
        },
        children: [{
          path: "/quoteList",
          name: "见绩书列表",
          component: function component() {
            return import("@/pages/order/inquiry/quoteList");
          },
          meta: {
            // icon: type,
            title: "见绩书列表",
            invisible: true,
            noCrumb: true
          }
        }, {
          path: "/quoteDetail",
          name: "见绩书详情",
          component: function component() {
            return import("@/pages/order/inquiry/quoteDetail");
          },
          meta: {
            // icon: type,
            title: "见绩书详情",
            invisible: true
          }
        }]
      }
      // {
      //   path: "/aftersaleslist",
      //   name: "aftersaleslist",
      //   component: () => import("@/pages/order/aftersaleslist"),
      //   meta: {
      //     title: "退换货列表",
      //   },
      // },
      ]
    }, {
      path: "/freightmanager",
      name: "2",
      component: BlankView,
      redirect: "/freightmanager/freightsetting",
      meta: {
        title: "配送管理",
        // icon: task
        icon: ps
      },
      children: [{
        path: "freightsetting",
        name: "运输天数设置",
        component: function component() {
          return import("@/pages/freightmanager/freightsetting");
        },
        meta: {
          title: "运输天数设置"
        }
      }, {
        path: "/sendtypesetting",
        name: "运输方式设置",
        component: function component() {
          return import("@/pages/freightmanager/sendtypesetting");
        },
        meta: {
          // icon: type,
          title: "运输方式设置"
        }
      }, {
        path: "/areaManagement",
        name: "收货地管理",
        component: function component() {
          return import("@/pages/freightmanager/areaManagement");
        },
        meta: {
          // icon: type,
          title: "收货地管理"
        }
      }]
    }, {
      path: "/marketing",
      name: "营销管理",
      component: BlankView,
      redirect: "/cardrecommend",
      meta: {
        title: "营销管理",
        // icon: task
        icon: yx
      },
      children: [
      // {
      //   path: "/cardrecommend",
      //   name: "购物车推荐",
      //   component: () => import("@/pages/marketing/cardrecommend"),
      //   meta: {
      //     title: "购物车推荐",
      //   },
      // },
      // {
      //   path: "coupon",
      //   name: "优惠券管理",
      //   component: BlankView,
      //   redirect: "coupon/couponList",
      //   meta: {
      //     title: "优惠券管理",
      //   },
      //   children: [
      //     {
      //       path: "couponList",
      //       name: "优惠券列表",
      //       component: () =>
      //         import("@/pages/marketing/coupon/couponList"),
      //       meta: {
      //         title: "优惠券列表",
      //         invisible: true,
      //       },
      //     },
      //     {
      //       path: "addcoupon",
      //       name: "新建优惠券",
      //       component: () =>
      //         import("@/pages/marketing/coupon/addcoupon/addCoupon"),
      //       meta: {
      //         title: "新建优惠券",
      //         invisible: true,
      //       },
      //     },
      //     {
      //       path: "editcoupon",
      //       name: "编辑优惠券",
      //       component: () =>
      //         import("@/pages/marketing/coupon/editcoupon"),
      //       meta: {
      //         title: "编辑优惠券",
      //         invisible: true,
      //       },
      //     },
      //     {
      //       path: "lookcoupon",
      //       name: "查看优惠券",
      //       component: () =>
      //         import("@/pages/marketing/coupon/lookcoupon/lookCoupon"),
      //       meta: {
      //         title: "查看优惠券",
      //         invisible: true,
      //       },
      //     },
      //   ],
      // },
      {
        path: "activity",
        name: "活动管理",
        component: BlankView,
        redirect: "activity/activityList",
        meta: {
          title: "活动管理"
          // keepAlive: true
        },
        children: [{
          path: "activityList",
          name: "活动列表",
          component: function component() {
            return import("@/pages/marketing/activity/activityList");
          },
          meta: {
            title: "活动列表",
            invisible: true,
            noCrumb: true
            // keepAlive: true
          }
        }, {
          path: "addActivity",
          name: "新建活动",
          component: function component() {
            return import("@/pages/marketing/activity/addactivity/addActivity");
          },
          meta: {
            title: "新建活动",
            invisible: true
          }
        }, {
          path: "editActivity",
          name: "编辑活动",
          component: function component() {
            return import("@/pages/marketing/activity/editActivity");
          },
          meta: {
            title: "编辑活动",
            invisible: true
          }
        }, {
          path: "lookActivity",
          name: "查看活动",
          component: function component() {
            return import("@/pages/marketing/activity/lookactivity/lookActivity");
          },
          meta: {
            title: "查看活动",
            invisible: true
          }
        }]
      },
      // {
      //   path: "/trackingList",
      //   name: "生成推广链接",
      //   component: () =>
      //     import("@/pages/marketing/tracking/trackingList"),
      //   meta: {
      //     title: "生成推广链接",
      //   },
      // },
      {
        path: "searchKeyword",
        name: "商品搜索关键字",
        component: BlankView,
        redirect: "searchKeyword/searchKeywordList",
        meta: {
          title: "商品搜索关键字"
        },
        children: [{
          path: "searchKeywordList",
          name: "商品搜索关键字列表",
          component: function component() {
            return import("@/pages/marketing/searchKeyword/searchKeywordList");
          },
          meta: {
            title: "商品搜索关键字列表",
            invisible: true
            // keepAlive: true
          }
        }, {
          path: "addSearchkeyword",
          name: "新建商品搜索关键字",
          component: function component() {
            return import("@/pages/marketing/searchKeyword/addSearchkeyword");
          },
          meta: {
            title: "新建商品搜索关键字",
            invisible: true
          }
        }, {
          path: "editSearchkeyword",
          name: "编辑商品搜索关键字",
          component: function component() {
            return import("@/pages/marketing/searchKeyword/editSearchkeyword");
          },
          meta: {
            title: "编辑商品搜索关键字",
            invisible: true
          }
        }]
      }]
    }, {
      path: "articlemanagement",
      name: "articlemanagement",
      component: BlankView,
      redirect: "articlemanagement/article",
      meta: {
        title: "文章管理",
        icon: wz
      },
      children: [{
        path: "article",
        name: "articlelist",
        component: function component() {
          return import("@/pages/articlemanagement/articlelist");
        },
        meta: {
          title: "文章列表"
        }
      }, {
        path: "editArticle",
        name: "editArticle",
        component: function component() {
          return import("@/pages/articlemanagement/editArticle");
        },
        meta: {
          title: "编辑文章",
          invisible: true,
          keepAlive: false
        }
      }, {
        path: "addArticle",
        name: "addArticle",
        component: function component() {
          return import("@/pages/articlemanagement/addArticle");
        },
        meta: {
          title: "新建文章",
          invisible: true,
          keepAlive: false
        }
      }, {
        path: "/news",
        name: "News",
        component: BlankView,
        redirect: "/news/list",
        children: [{
          path: "/news/list",
          name: "NewsList",
          component: function component() {
            return import("@/pages/articlemanagement/NewsManagement/NewsList");
          },
          meta: {
            title: "新着情报",
            invisible: true,
            noCrumb: true
          }
        }, {
          path: "/news/add",
          name: "NewsAdd",
          component: function component() {
            return import("@/pages/articlemanagement/NewsManagement/NewsDetail");
          },
          meta: {
            title: "新增情报",
            invisible: true
          }
        }, {
          path: "/news/edit",
          name: "NewsEdit",
          component: function component() {
            return import("@/pages/articlemanagement/NewsManagement/NewsDetail");
          },
          meta: {
            title: "编辑情报",
            invisible: true
          }
        }]
      }]
    },
    //   {
    //     path: 'affiliate',
    //     name: 'affiliate',
    //     component: BlankView,
    //     redirect: 'affiliate/brokerage',
    //     meta: {
    //       title: '分销联盟',
    //       icon: affiliate,

    //     },
    //     children: [
    //       {
    //         path: 'brokerage',
    //         name: 'brokerage',
    //         component: () => import('@/pages/affiliate/brokerage'),
    //         meta: {
    //           title: '佣金规则',

    //         }
    //       },
    // {
    //   path: 'poster',
    //   name: 'poster',
    //   component: () => import('@/pages/affiliate/poster'),
    //   meta: {
    //     title: '海报规约',

    //   }
    // },
    //       {
    //         path: 'databoard',
    //         name: 'databoard',
    //         component: () => import('@/pages/affiliate/databoard'),
    //         meta: {
    //           title: '数据看板',

    //         }
    //       },

    //       {
    //         path: 'distribution',
    //         name: 'distribution',
    //         component: () => import('@/pages/affiliate/distribution'),
    //         meta: {
    //           title: '分销员管理',

    //         }
    //       },
    //       {
    //         path: 'settlementmanager',
    //         name: 'settlementmanager',
    //         component: BlankView,
    //         redirect: 'settlementmanager/settlement',
    //         meta: {
    //           title: '结算管理',

    //         },
    //         children: [
    //           {
    //             path: 'settlement',
    //             name: 'settlement',
    //             component: () => import('@/pages/affiliate/settlement'),
    //             meta: {
    //               title: '结算管理',
    //               invisible: true,

    //             },
    //           },
    //           {
    //             path: 'order',
    //             name: 'order',
    //             component: () => import('@/pages/affiliate/settlement/order'),
    //             meta: {
    //               title: '订单明细',
    //               invisible: true,

    //             },
    //           }
    //         ]
    //       },
    //     ]

    //   },

    {
      path: "systemsetting",
      name: "systemsetting",
      component: BlankView,
      redirect: "systemsetting/basicsetting",
      meta: {
        title: "系统设置",
        icon: sz
      },
      children: [{
        path: "basicsetting",
        name: "basicsetting",
        component: function component() {
          return import("@/pages/systemsettings/basicSettings");
        },
        meta: {
          title: "基础信息"
        }
      },
      // {
      //   path: "feesetting",
      //   name: "货到付款手续费",
      //   component: () => import("@/pages/freightmanager/feesetting"),
      //   meta: {
      //     title: "货到付款手续费",
      //     invisible: true,
      //   },
      // },
      {
        path: "holidayset",
        name: "假期设置",
        component: function component() {
          return import("@/pages/systemsettings/holiday/holidayset");
        },
        meta: {
          // icon: type,
          title: "假期设置"
        }
      },
      // {
      //   path: "deliveryChannelManagement",
      //   name: "deliveryChannelManagement",
      //   component: () =>
      //     import("@/pages/systemsettings/deliveryChannelManagement"),
      //   meta: {
      //     // icon: type,
      //     title: "假期设置",
      //   },
      // },
      {
        path: "accountList",
        name: "账号列表",
        component: function component() {
          return import("@/pages/systemsettings/account/list");
        },
        meta: {
          // icon: type,
          title: "账号列表"
        }
      }, {
        path: "deploy",
        name: "部署设置",
        component: function component() {
          return import("@/pages/systemsettings/deploy");
        },
        meta: {
          // icon: type,
          title: "部署设置"
        }
      }, {
        path: "hotwords",
        name: "搜索热词",
        component: function component() {
          return import("@/pages/systemsettings/hotwords/hotWords");
        },
        meta: {
          // icon: type,
          title: "搜索热词"
        }
      }]
    }]
  }]
};
export default options;